import React from 'react';
import config from '../../config';

export default function PrivacyPolicy() {
	return (
		<a href={config.privacyPolicyUrl} target='_blank' rel="noopener noreferrer">Privacy Policy</a>
	)
}

